import React, { useContext } from 'react'
import { RegistrationFormContext } from './types'
import { InputElement } from '../../../../HtmlComponents/InputElement'
import { InputRadio } from '../../../../HtmlComponents/InputRadio'

const Section4 = () => {
  const { 
    publicServiceOrMilitaryRecruitment, setPublicServiceOrMilitaryRecruitment,
    privateSectorEmploymentInMauritania, setPrivateSectorEmploymentInMauritania,
    foreignProfessionalPracticeInMauritania, setForeignProfessionalPracticeInMauritania,
    
    modeOfExercise, setModeOfExercise,
    salaryType, setSalaryType,
    employerName, setEmployerName,

    status, setStatus,
    country, setCountry,

   } = useContext(RegistrationFormContext)

  return (
    <>
    <div>
        <p className='font-bold text-main'>{"23) "}Préciser la date exacte de votre: </p>
        <InputElement inputClass='md:w-1/2' type='date' name="Recrutement dans les services publics ou de l'armée" value={publicServiceOrMilitaryRecruitment} setValue={setPublicServiceOrMilitaryRecruitment}/>
        <InputElement inputClass='md:w-1/2' type='date' name="Installation dans le secteur privé mauritanien" value={privateSectorEmploymentInMauritania} setValue={setPrivateSectorEmploymentInMauritania}/>
        <InputElement inputClass='md:w-1/2' type='date' name="Exercice en Mauritanie pour les étrangers" value={foreignProfessionalPracticeInMauritania} setValue={setForeignProfessionalPracticeInMauritania}/>
      </div>
      <div>
        <p className='font-bold text-main'>{"24) "}Quelle est votre mode d'exercice: </p>
        <InputRadio 
          checked={modeOfExercise === "Salaire exclusif" && true} 
          labelName='Salaire exclusif' 
          id='SalaireExclusif' 
          value={"Salaire exclusif"} 
          setValue={setModeOfExercise}
        />
        <InputRadio 
          checked={modeOfExercise === "Medecine privée exclusive" && true} 
          labelName='Medecine privée exclusive' 
          id='MedecinePrivéeExclusive' 
          value={"Medecine privée exclusive"} 
          setValue={setModeOfExercise}
        />
        <InputRadio 
          checked={modeOfExercise === "Salaire et médecine privée" && true} 
          labelName='Salaire et médecine privée' 
          id='SalaireEtMédecinePrivée' 
          value={"Salaire et médecine privée"} 
          setValue={setModeOfExercise}
        />
      </div>
      <div>
        <p className='font-bold text-main'>{"25) "}Quelle est votre mode d'exercice: </p>
        <InputRadio 
          checked={salaryType === "Etat" && true} 
          labelName='Etat' 
          id='salaryTypeEtat' 
          value={"Etat"} 
          setValue={setSalaryType}
        />
        <InputRadio 
          checked={salaryType === "Organisme" && true} 
          labelName='Organisme' 
          id='salaryTypeOrganisme' 
          value={"Organisme"} 
          setValue={setSalaryType}
        />
        {salaryType === "Organisme" && <InputElement inputClass='md:w-1/2' name="Précisez le nom de votre employeur" value={employerName} setValue={setEmployerName}/>}
      </div>
      <div>
        <p className='font-bold text-main'>{"26) "}exercez-vous en tantque medecin etranger: </p>
        <InputRadio 
          checked={status === "Cooperant" && true} 
          labelName='Coopérant' 
          id='statusCooperant' 
          value={"Cooperant"} 
          setValue={setStatus}
        />
        {status === "Cooperant"  && <InputElement name='Precisez votre pays' value={country} setValue={setCountry}/>}
        <InputRadio 
          checked={status === "Salaire Payé par l'etat mauritanien" && true} 
          labelName="Salaire Payé par l'etat mauritanien" 
          id="SalairePayéParEtatMauritanien" 
          value={"Salaire Payé par l'etat mauritanien"} 
          setValue={setStatus}
        />
        <InputRadio 
          checked={status === "Salaire Payé par un privé mauritanien" && true} 
          labelName="Salaire Payé par un privé mauritanien"
          id="SalairePayéParUnPrivéMauritanien" 
          value={"Salaire Payé par un privé mauritanien"} 
          setValue={setStatus}
        />
      </div>
    </>
  )
}

export default Section4